import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'service-provider-relation'
const single = 'service-provider-relation'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	single: single
})

api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}?${params}`)
		.then(handleResponse)
		.catch(handleError);
}

api.addClientRelationship = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.clientRelationsApprove = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/approve`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.clientRelationsReject = (body) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/reject`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.clientRelationsRevoke = (body) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/revoke`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.clientRelationsCancel = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/cancel`, body)
		.then(handleResponse)
		.catch(handleError);
}

export default api
